"use client";

import { c as _c } from "react/compiler-runtime";
import { Button } from "@opensea/next-ui-kit";
import { Media } from "@opensea/ui-kit";
import { CollapseContent, ExpandContent } from "@opensea/ui-kit/icons";
import { useHeroHeaderView } from "./HeroHeaderViewProvider";
export function HeroHeaderViewToggle() {
  const $ = _c(6);
  const {
    headerView,
    setHeaderView
  } = useHeroHeaderView();
  const t0 = headerView === "full" ? CollapseContent : ExpandContent;
  let t1;
  if ($[0] !== headerView || $[1] !== setHeaderView) {
    t1 = () => {
      setHeaderView(headerView === "full" ? "compact" : "full");
    };
    $[0] = headerView;
    $[1] = setHeaderView;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== t0 || $[4] !== t1) {
    t2 = <Media greaterThanOrEqual="lg"><Button icon={t0} onClick={t1} size="sm" variant="secondary-transparent" /></Media>;
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
}